import React, { createContext, useReducer } from 'react';

const initialState = {
  chatLog: [],
  userId: localStorage.getItem('user_id') || null,  // corrected key from 'user_Id' to 'user_id'
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'ADD_MESSAGE':
        const newChatLog = [...state.chatLog, action.payload];
        return {
          ...state,
          chatLog: newChatLog,
          lastAddedIndex: newChatLog.length - 1, // Track the index of the last added message
        };
      case 'UPDATE_MESSAGE':
        return {
          ...state,
          chatLog: state.chatLog.map((msg, index) => 
            index === action.index ? action.payload : msg
          ),
        };
      case 'CLEAR_CHAT_LOG':
        return {
          ...state,
          chatLog: [],
          lastAddedIndex: -1,
        };
      default:
        return state;
    }
  };
  

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addMessageToChatLog = (message) => {
    dispatch({ type: 'ADD_MESSAGE', payload: { user: message.user, message: message.message } });
    return state.chatLog.length; // Return the index where the message will be placed
  };

  const updateMessageInChatLog = (index, message) => {
    dispatch({ type: 'UPDATE_MESSAGE', index: index, payload: { user: message.user, message: message.message } });
  };

  const clearChatLog = () => {
    dispatch({ type: 'CLEAR_CHAT_LOG' });
  };

  return (
    <ChatContext.Provider value={{ chatLog: state.chatLog, addMessageToChatLog, updateMessageInChatLog, clearChatLog }}>
      {children}
    </ChatContext.Provider>
  );
};
